import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
};

export type ChangeShipmentModalityData = {
  cartId: string;
  phone?: string;
  pickupInStore?: Array<{
    storeId: string;
    type: string;
  }>;
  delivery?: Array<{
    shipmentId: string;
    type: string;
    options?: {
      scheduleDelivery?: string;
      periodDelivery?: string;
    };
  }>;
};

type Body = {
  phone?: {
    number: string;
  };
  pickupInStore?: Array<{
    storeId: string;
    type: string;
  }>;
  delivery?: Array<{
    shipmentId: string;
    type: string;
    options?: {
      scheduleDelivery?: string;
      periodDelivery?: string;
    };
  }>;
};

export type Response = {
  data: {
    cartId: string;
    shipmentId: string;
    modalityType: string;
  };
};

const changeShipmentModality: ServiceMethod<
  Response,
  ChangeShipmentModalityData
> = (httpClient) => async (data, options) => {
  const { cartId, phone, pickupInStore, delivery } = data;

  const body: Body = {};

  if (phone) {
    body.phone = { number: phone };
  }

  if (pickupInStore) {
    body.pickupInStore = pickupInStore;
  }

  if (delivery) {
    body.delivery = delivery;
  }

  const { body: response } = await httpClient.put<Response, Body, Params>(
    '/api/v3/carts/{cartId}/shipments/select-modalities',
    {
      ...options,
      body,
      params: { cartId },
    }
  );

  return response;
};

export default changeShipmentModality;
